import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import {
  useAuth,
  // useFormSociogramPage,
  useSurveyByUser,
  useGetResponsesByPage,
  useSurveyQuestionsByPage,
  useCreateQuestionResponse,
  useGetSurveysSociogram,
  useSendParticpantsTerminated,
} from '@BUP/hooks';
import {
  PageLayout,
  BupSpinner,
  ErrorMessage,
  QuestionsList,
} from '@BUP/components';

const SociogramPageById = () => {
  const history = useHistory();
  const [, forceUpdate] = useState();
  // const { form } = useFormSociogramPage();
  const { user } = useAuth();
  const { pageId } = useParams();
  const enrollmentId = user?.enrollmentId;
  const [page, setPage] = useState(
    pageId > 0 ? parseInt(pageId, 10) : pageId === 0 ? 0 : 1
  );
  const { isLoadingSurvey, survey, errorSurvey } = useSurveyByUser(user);
  const companions = survey?.companions;
  companions?.sort((obj1, obj2) => {
    if (obj1.name < obj2.name) {
      return -1;
    }
    if (obj1.name > obj2.name) {
      return 1;
    }
    return 0;
  });

  const { isLoadingResponsesByPage } = useGetResponsesByPage(
    user,
    survey,
    page
  );

  const {
    isLoadingQuestions,
    errorQuestions,
    questions,
  } = useSurveyQuestionsByPage(survey?.id, page);
  const { saveAllResponsesByPage, loadingResponse } = useCreateQuestionResponse(
    {
      enrollmentId,
      surveyId: survey?.id,
    }
  );

  const { surveySociogram } = useGetSurveysSociogram(user);

  const {
    sendEnrollmentId,
    dataResponse,
    loadingResponse: loadingParticipantsTerminated,
  } = useSendParticpantsTerminated();

  const handleFormSubmit = async (responses) => {
    const nextPage = parseInt(page, 10) + 1;
    try {
      await saveAllResponsesByPage(responses);
      // Se asumió que el sociograma tendría 4 paginas, por esto, si se intenta acceder a una mayor se asumira que termino.
      if (nextPage > 4) {
        await sendEnrollmentId({
          data: {
            enrollmentId,
            survey: surveySociogram?.id,
          },
        });
        if (dataResponse) {
          history.push('/data/sociogram/finish');
        }
      } else {
        setPage(nextPage);
      }
    } catch (error) {
      console.log('Ocurrió un error en submit response', error);
    }
  };
  // const goToPreviousPage = () => setPage(parseInt(page, 10) - 1);

  useEffect(() => {
    if (page > 0) {
      history.replace(`/data/sociogram/${page}`);
    }
    if (page === 0) {
      history.replace('/data/sociogram');
    }
  }, [page]);
  useEffect(() => {
    forceUpdate({});
  }, []);
  return (
    <PageLayout pageName={`${survey?.name || ''}`}>
      {isLoadingSurvey ||
      isLoadingQuestions ||
      isLoadingResponsesByPage ||
      loadingResponse ||
      loadingParticipantsTerminated ? (
        <BupSpinner size="large" />
      ) : errorSurvey || errorQuestions ? (
        <>
          <h2>
            {errorSurvey?.message || null}/{errorQuestions?.message || null}
          </h2>
          <ErrorMessage />
        </>
      ) : (
        <>
          <QuestionsList
            title={questions?.[0]?.page_id?.name}
            questions={questions}
            classMates={companions}
            onSubmit={handleFormSubmit}
            // onPreviousPage={goToPreviousPage}
          />
        </>
      )}
    </PageLayout>
  );
};
export default SociogramPageById;
